import type { UseQueryResult } from "@tanstack/react-query";
import { CONSTANT } from "@/shared/constants/constant";

import { fetchList } from "../api/fetch/fetchList";
import useFetchHook from "@/shared/hooks/useFetchHook";
import {
  defaultListParams,
  defaultListParamsv2,
  filterParams,
} from "@/shared/model/defaultParams";

type CriteriaPayload = {
  logical: "AND" | "OR";
  conditions: filterParams | filterParams[];
};

type UseFetchListPayload =
  | defaultListParams
  | defaultListParamsv2
  | CriteriaPayload;

const useFetchList = <T>(
  data: UseFetchListPayload,
  endpoint: string,
  options?: {}
): UseQueryResult<T> => {
  const fetchQueryFn = fetchList({ ...data, endpoint });

  const fetchQuery: UseQueryResult<T> = useFetchHook<T>({
    keys: fetchQueryFn.key,
    api: fetchQueryFn.api,
    options: {
      ...options,
      meta: {
        errorMessage: CONSTANT.REQUEST_FAILED,
      },
    },
  });

  return {
    ...fetchQuery,
  };
};

export default useFetchList;
